import { useState } from "react"

export default function ProductGroupAccordion() {
    const PRODUCT_GROUPS = [
        {
            id: 1,
            label: "Bổ sung vitamin, khoáng chất",
            subs: [
                "Dinh dưỡng bổ sung",
                "Dầu cá, omega 3",
            ],
        },
        {
            id: 2,
            label: "Chăm sóc cá nhân",
            subs: [
                "Dinh dưỡng bổ sung",
                "Dầu cá, omega 3",
            ],
        },
        { id: 3, label: "Chăm sóc da" },
        { id: 4, label: "Chăm sóc tóc - da đầu" },
        { id: 5, label: "Cơ, xương, khớp" },
        { id: 6, label: "Da liễu" },
        { id: 7, label: "Đái tháo đường" },
        { id: 8, label: "Đồ dùng gia đình, mẹ và bé" },
        { id: 9, label: "Dụng cụ y tế và sản phẩm khác" },
        { id: 10, label: "Gan, mật" },
        { id: 11, label: "Giảm đau, hạ sốt, kháng viêm" },
        { id: 12, label: "Hỗ trợ cơ, xương, khớp" },
        { id: 13, label: "Hỗ trợ đái tháo đường" },
        { id: 14, label: "Hỗ trợ gan, mật" },
        { id: 15, label: "Hỗ trợ làm đẹp" },
        { id: 16, label: "Hỗ trợ não, thần kinh" },
        { id: 17, label: "Hỗ trợ tai, mũi, họng" },
        { id: 18, label: "Hỗ trợ tạo máu" },
        { id: 19, label: "Hỗ trợ tiêu hóa, dạ dày" },
        { id: 20, label: "Hỗ trợ ung thư, miễn dịch" },
        { id: 21, label: "Hormon, sinh lý" },
        { id: 22, label: "Kháng Histamin (Chống dị ứng)" },
        { id: 23, label: "Kháng vi sinh vật" },
        { id: 24, label: "Mắt" },
        { id: 25, label: "Máu, huyết học" },
        { id: 26, label: "Miếng dán, dầu, cao xoa" },
        { id: 27, label: "Não, thần kinh" },
        { id: 28, label: "Sinh lý, nội tiết tố" },
        { id: 29, label: "Sức khỏe giới tính" },
        { id: 30, label: "Sức khỏe mắt" },
        { id: 31, label: "Sức khỏe tim, mạch, huyết áp" },
        { id: 32, label: "Tai, mũi, họng" },
        { id: 33, label: "Thiết bị theo dõi" },
        { id: 34, label: "Thực phẩm bổ sung" },
        { id: 35, label: "Thực phẩm, đồ uống" },
        { id: 36, label: "Tiêu hóa, dạ dày" },
        { id: 37, label: "Tim, mạch, huyết áp" },
        { id: 38, label: "Ung thư, miễn dịch" },
        { id: 39, label: "Vật tư y tế tiêu hao" },
        { id: 40, label: "Vệ sinh, sát khuẩn" },
        { id: 41, label: "Vitamin, khoáng chất" },
    ]
    const [accordionOpen, setAccordionOpen] = useState(true)
    const [activeId, setActiveId] = useState<number | null>(null)

    interface ProductGroup {
        id: number;
        label: string;
        subs?: string[];
    }

    const toggleAccordion = () => {
        setAccordionOpen(prev => !prev)
    }


    const toggleItem = (id: number): void => {
        setActiveId((prev: number | null) => (prev === id ? null : id));
    }

    return (
        <div className="MuiPaper-root MuiAccordion-root filter-product-accordion Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded lh-1-5">

            <button className="styles_accordionHeader__xUFrY" onClick={toggleAccordion}>
                <p>Nhóm sản phẩm</p>
                <span className={[accordionOpen ? "styles_buttonExpand__QQLBp styles_buttonExpanded__jSTHs" : "styles_buttonExpand__QQLBp"].join(" ")}>
                    <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>
                </span>
            </button>

            {accordionOpen && (
                <div className="MuiCollapse-root MuiCollapse-entered" style={{ minHeight: "0px" }}>
                    <div className="MuiCollapse-wrapper">
                        <div className="MuiCollapse-wrapperInner">
                            <div role="region">
                                <div className="MuiAccordionDetails-root accordion-detail" style={{ display: "block" }}>
                                    <div className="styles_containerList__c3d5v styles_itemList__qvTM4">

                                        {PRODUCT_GROUPS.map(item => {
                                            const isActive = activeId === item.id

                                            return (
                                                <div key={item.id} style={{ width: "100%" }}>
                                                    {/* MAIN ITEM */}
                                                    <button
                                                        className={[
                                                            "styles_item__rQ1Ka",
                                                            "styles_itemWithDropdown__58jnU",
                                                            isActive && "styles_activeItem__7Yk8F",
                                                        ].filter(Boolean).join(" ")}
                                                        onClick={() => toggleItem(item.id)}
                                                    >
                                                        <span>{item.label}</span>

                                                        <span
                                                            className={[
                                                                "styles_dropdownIcon__KxDhe",
                                                                isActive && "styles_dropdownIconActive__2VJI0",
                                                            ].filter(Boolean).join(" ")}
                                                        >
                                                            <svg width="20" height="20" viewBox="0 0 20 20">
                                                                <path
                                                                    d="M10.3072 12.1313C10.1473 12.3232 9.85255 12.3232 9.69263 12.1313L6.37998 8.15607C6.16287 7.89554 6.34813 7.5 6.68727 7.5L13.3126 7.5C13.6517 7.5 13.837 7.89554 13.6199 8.15607L10.3072 12.1313Z"
                                                                    fill={isActive ? "white" : "#728091"}
                                                                />
                                                            </svg>
                                                        </span>
                                                    </button>

                                                    {/* SUB ITEMS */}
                                                    {isActive && item.subs && (
                                                        <div className="styles_subEffWrapper__1f7Dz">
                                                            {item.subs.map(sub => (
                                                                <button key={sub} className="styles_subEffItem__xE1nQ">
                                                                    <span>{sub}</span>
                                                                </button>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}
